(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-tiles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousel = document.querySelector('[data-cat-carousel]');
    var track = document.querySelector('[data-cat-track]');
    var prevBtn = document.querySelector('[data-cat-prev]');
    var nextBtn = document.querySelector('[data-cat-next]');
    if (!track || !prevBtn || !nextBtn) return;

    var tiles = track.querySelectorAll('.cat-tile');
    if (tiles.length === 0) return;

    function scrollAmount() {
      var tileWidth = tiles[0].getBoundingClientRect().width + 12;
      return tileWidth;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-cta-track]');
    if (!track) return;
    var items = track.querySelectorAll('.cta-banner__benefit');
    if (items.length <= 1) return;

    var timer = null;
    var paused = false;

    function isMobile() {
      return window.matchMedia('(max-width: 600px)').matches;
    }

    function nextSlide() {
      if (paused || !isMobile()) return;
      var itemWidth = items[0].getBoundingClientRect().width;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var target = track.scrollLeft + itemWidth;
      if (target >= maxScroll - 5) target = 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isMobile()) return;
      timer = setInterval(nextSlide, 3500);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    track.addEventListener('touchstart', function () {
      paused = true;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function () {
      paused = false;
      setTimeout(startAutoplay, 2000);
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) { startAutoplay(); } else { stopAutoplay(); track.scrollLeft = 0; }
      }, 250);
    });

    if (isMobile()) { track.scrollLeft = 0; }
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript.closest('.featured-products') || document.querySelector('[data-featured-products]');
    if (!section) return;

    // Tab switching
    var pills = section.querySelectorAll('[data-tab]');
    var panels = section.querySelectorAll('[data-panel]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var tabId = pill.getAttribute('data-tab');
        pills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');
        panels.forEach(function (panel) {
          if (panel.getAttribute('data-panel') === tabId) {
            panel.classList.add('is-active');
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('is-active');
            panel.setAttribute('hidden', '');
          }
        });
      });
    });

    // Carousel controls
    var carousels = section.querySelectorAll('[data-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-track]');
      var prevBtn = carousel.querySelector('[data-nav-prev]');
      var nextBtn = carousel.querySelector('[data-nav-next]');

      function getScrollAmount() {
        var slide = track.querySelector('.featured-products__slide');
        return slide ? slide.offsetWidth + 16 : 300;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-predictive-search]');
    if (!form) return;

    /* Category dropdown toggle */
    var catTrigger = form.querySelector('[data-category-trigger]');
    var catDropdown = form.querySelector('[data-category-dropdown]');
    if (catTrigger && catDropdown) {
      catTrigger.addEventListener('click', function (e) {
        if (e.target.closest('[data-category-dropdown]')) return;
        e.preventDefault();
        e.stopPropagation();
        var hidden = catDropdown.getAttribute('hidden') !== null;
        if (hidden) { catDropdown.removeAttribute('hidden'); } else { catDropdown.setAttribute('hidden', ''); }
      });
      document.addEventListener('click', function (e) {
        if (!catTrigger.contains(e.target)) {
          catDropdown.setAttribute('hidden', '');
        }
      });
    }

    var input = form.querySelector('[data-search-input]');
    var dropdown = form.querySelector('[data-search-dropdown]');
    var resultsContainer = form.querySelector('[data-search-results]');
    var loading = form.querySelector('[data-search-loading]');
    var footer = form.querySelector('[data-search-footer]');
    var empty = form.querySelector('[data-search-empty]');
    var header = form.querySelector('[data-search-header]');
    var queryText = form.querySelector('[data-search-query-text]');
    var countEl = form.querySelector('[data-search-count]');
    var debounceTimer = null;
    var currentRequest = null;
    var activeIndex = -1;

    function formatMoney(cents) {
      var amount = (cents / 100).toLocaleString('es-CL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return '$' + amount;
    }

    function escapeHtml(str) {
      if (!str) return '';
      return str.replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function showDropdown() {
      dropdown.removeAttribute('hidden');
    }
    function hideDropdown() {
      dropdown.setAttribute('hidden', '');
      activeIndex = -1;
    }

    function renderResults(products, query) {
      resultsContainer.innerHTML = '';
      if (products.length === 0) {
        loading.setAttribute('hidden', '');
        footer.setAttribute('hidden', '');
        header.setAttribute('hidden', '');
        empty.removeAttribute('hidden');
        return;
      }
      empty.setAttribute('hidden', '');
      loading.setAttribute('hidden', '');

      // Header
      queryText.textContent = query;
      countEl.textContent = products.length + ' resultado' + (products.length !== 1 ? 's' : '');
      header.removeAttribute('hidden');

      products.forEach(function (product, index) {
        var item = document.createElement('a');
        item.className = 'himer-search__result';
        item.href = product.url;
        item.setAttribute('data-index', index);

        var imageHtml = '';
        if (product.featured_image && product.featured_image.url) {
          imageHtml = '<div class="himer-search__result-image-wrap">' +
            '<img class="himer-search__result-image" src="' + product.featured_image.url + '&width=60&height=60" alt="' + escapeHtml(product.title) + '" width="60" height="60" loading="lazy">' +
            '</div>';
        } else {
          imageHtml = '<div class="himer-search__result-image-wrap">' +
            '<div class="himer-search__result-image-placeholder">' +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h7"/><path d="M16 11l4 4-4 4"/></svg>' +
            '</div></div>';
        }

        var vendorHtml = product.vendor ? '<span class="himer-search__result-vendor">' + escapeHtml(product.vendor) + '</span>' : '';

        var tagHtml = '';
        if (product.tags && product.tags.length > 0) {
          var firstTag = product.tags[0];
          tagHtml = '<span class="himer-search__result-tag">' + escapeHtml(firstTag) + '</span>';
        }

        var rightHtml = '';
        if (product.available) {
          rightHtml = '<div class="himer-search__result-right">' +
            '<span class="himer-search__result-price">' + formatMoney(product.price) + '</span>' +
            '<span class="himer-search__result-badge himer-search__result-badge--available">Disponible</span>' +
            '</div>';
        } else {
          rightHtml = '<div class="himer-search__result-right">' +
            '<span class="himer-search__result-badge himer-search__result-badge--soldout">Agotado</span>' +
            '</div>';
        }

        item.innerHTML =
          imageHtml +
          '<div class="himer-search__result-info">' +
            '<div class="himer-search__result-title">' + escapeHtml(product.title) + '</div>' +
            '<div class="himer-search__result-meta">' + vendorHtml + tagHtml + '</div>' +
          '</div>' +
          rightHtml;

        resultsContainer.appendChild(item);
      });

      footer.removeAttribute('hidden');
    }

    function performSearch(query) {
      if (currentRequest) {
        currentRequest.abort();
      }
      if (!query || query.trim().length < 2) {
        hideDropdown();
        return;
      }

      loading.removeAttribute('hidden');
      empty.setAttribute('hidden', '');
      footer.setAttribute('hidden', '');
      resultsContainer.innerHTML = '';
      showDropdown();

      currentRequest = new XMLHttpRequest();
      var searchUrl = form.getAttribute('data-search-url');
      var url = searchUrl + '/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.sku,vendor,tag';

      currentRequest.open('GET', url, true);
      currentRequest.onreadystatechange = function () {
        if (currentRequest.readyState !== 4) return;
        if (currentRequest.status !== 200) return;

        try {
          var data = JSON.parse(currentRequest.responseText);
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, query);
        } catch (e) {
          loading.setAttribute('hidden', '');
        }
      };
      currentRequest.send();
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        performSearch(query);
      }, 250);
    });

    input.addEventListener('focus', function () {
      var query = input.value.trim();
      if (query.length >= 2) {
        performSearch(query);
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) {
        hideDropdown();
      }
    });

    // Keyboard navigation
    input.addEventListener('keydown', function (e) {
      var items = resultsContainer.querySelectorAll('.himer-search__result');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (items.length === 0) return;
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        items.forEach(function (item, i) {
          item.classList.toggle('is-active', i === activeIndex);
        });
        if (items[activeIndex]) items[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (items.length === 0) return;
        activeIndex = Math.max(activeIndex - 1, -1);
        items.forEach(function (item, i) {
          item.classList.toggle('is-active', i === activeIndex);
        });
      } else if (e.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) {
        e.preventDefault();
        window.location.href = items[activeIndex].href;
      } else if (e.key === 'Escape') {
        hideDropdown();
        input.blur();
      }
    });
  })();

  /* Mobile menu toggle */
  (function () {
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var backdrop = document.querySelector('[data-mobile-menu-backdrop]');
    if (!toggle || !menu || !backdrop) return;

    function openMenu() {
      menu.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', openMenu);
    backdrop.addEventListener('click', closeMenu);
    menu.querySelector('[data-mobile-menu-close]').addEventListener('click', closeMenu);
    menu.querySelectorAll('[data-mobile-menu-link]').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  })();

  /* Utility bar rotator (mobile only) */
  (function () {
    var rotator = document.querySelector('[data-utility-rotator]');
    if (!rotator) return;
    var items = rotator.querySelectorAll('[data-utility-item]');
    var prevBtn = rotator.querySelector('[data-utility-prev]');
    var nextBtn = rotator.querySelector('[data-utility-next]');
    if (items.length <= 1) return;

    var current = 0;
    var timer = null;

    function isMobile() {
      return window.matchMedia('(max-width: 600px)').matches;
    }

    function show(index) {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }

    function rotate() {
      current = (current + 1) % items.length;
      show(current);
    }

    function start() {
      stop();
      if (!isMobile()) return;
      show(current);
      timer = setInterval(rotate, 4000);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        current = (current - 1 + items.length) % items.length;
        show(current);
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        rotate();
        start();
      });
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(start, 250);
    });

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;
    var track = slider.querySelector('[data-hero-track]');
    var slides = slider.querySelectorAll('[data-hero-slide]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var autoplay = slider.dataset.autoplay === 'true';
    var interval = parseInt(slider.dataset.interval || '5000', 10);
    var current = 0;
    var total = slides.length;
    var timer = null;

    function goTo(index) {
      if (total === 0) return;
      current = ((index % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay || total <= 1) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    /* Pause on hover */
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    /* Touch / swipe */
    var touchStartX = 0;
    var touchEndX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) { next(); } else { prev(); }
      }
      startAutoplay();
    }, { passive: true });

    /* Keyboard */
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { prev(); startAutoplay(); }
      if (e.key === 'ArrowRight') { next(); startAutoplay(); }
    });

    startAutoplay();
  })();

  /* Chips carousel autoplay (mobile) */
  (function () {
    var chipsContainers = document.querySelectorAll('.hero-section__chips');
    chipsContainers.forEach(function (track) {
      var chips = track.querySelectorAll('.hero-section__chip');
      if (chips.length <= 1) return;

      var timer = null;
      var paused = false;

      function isMobile() {
        return window.matchMedia('(max-width: 600px)').matches;
      }

      function nextChip() {
        if (paused || !isMobile()) return;
        var chipWidth = chips[0].getBoundingClientRect().width;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var target = track.scrollLeft + chipWidth;
        if (target >= maxScroll - 5) target = 0;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      function start() {
        stop();
        if (!isMobile()) return;
        timer = setInterval(nextChip, 3500);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      track.addEventListener('touchstart', function () {
        paused = true;
        stop();
      }, { passive: true });
      track.addEventListener('touchend', function () {
        paused = false;
        setTimeout(start, 2000);
      }, { passive: true });

      if (isMobile()) { track.scrollLeft = 0; }
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-split"] && !Shopify.designMode) return;
  try {
    
  /* Toggle recover/login + password visibility */
  document.addEventListener('DOMContentLoaded', function () {
    var loginSection = document.getElementById('LoginSection');
    var recoverSection = document.getElementById('RecoverSection');
    var toggles = document.querySelectorAll('[data-recover-toggle]');

    toggles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var isLoginVisible = loginSection.style.display !== 'none';
        loginSection.style.display = isLoginVisible ? 'none' : 'block';
        recoverSection.style.display = isLoginVisible ? 'block' : 'none';
      });
    });

    /* Password visibility */
    document.querySelectorAll('[data-toggle-password]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.querySelector('[data-password-input]');
        if (!input) return;
        input.type = input.type === 'password' ? 'text' : 'password';
      });
    });

    /* Hash-based recover */
    if (window.location.hash === '#recover') {
      var t = document.querySelector('[data-recover-toggle]');
      if (t) { t.click(); }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-promo-track]');
    if (!track) return;
    var items = track.querySelectorAll('.promo-panel__benefit');
    if (items.length <= 1) return;

    var timer = null;
    var paused = false;

    function isMobile() {
      return window.matchMedia('(max-width: 600px)').matches;
    }

    function nextSlide() {
      if (paused || !isMobile()) return;
      var itemWidth = items[0].getBoundingClientRect().width;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var target = track.scrollLeft + itemWidth;
      if (target >= maxScroll - 5) target = 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isMobile()) return;
      timer = setInterval(nextSlide, 3500);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    track.addEventListener('touchstart', function () {
      paused = true;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function () {
      paused = false;
      setTimeout(startAutoplay, 2000);
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) { startAutoplay(); } else { stopAutoplay(); }
      }, 250);
    });

    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-testimonials-track]');
    var prevBtn = document.querySelector('[data-testimonials-prev]');
    var nextBtn = document.querySelector('[data-testimonials-next]');
    if (!track) return;
    var items = track.querySelectorAll('.testimonial-card');
    if (items.length === 0) return;

    var timer = null;
    var paused = false;

    function isMobile() {
      return window.matchMedia('(max-width: 600px)').matches;
    }

    function scrollAmount() {
      return items[0].getBoundingClientRect().width + 56;
    }

    function nextSlide() {
      if (paused || !isMobile()) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var target = track.scrollLeft + scrollAmount();
      if (target >= maxScroll - 5) target = 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isMobile()) return;
      timer = setInterval(nextSlide, 4000);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('touchstart', function () {
      paused = true;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function () {
      paused = false;
      setTimeout(startAutoplay, 2000);
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) { startAutoplay(); } else { stopAutoplay(); }
      }, 250);
    });

    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousel = document.querySelector('[data-trust-carousel]');
    var track = document.querySelector('[data-trust-track]');
    if (!carousel || !track) return;
    var items = track.querySelectorAll('.trust-bar__item');
    if (items.length <= 1) return;

    var timer = null;
    var paused = false;
    var interval = 3500;

    function isMobile() {
      return window.matchMedia('(max-width: 600px)').matches;
    }

    function nextSlide() {
      if (paused || !isMobile()) return;
      var trackRect = track.getBoundingClientRect();
      var itemWidth = items[0].getBoundingClientRect().width + 12;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var current = track.scrollLeft;
      var target = current + itemWidth;
      if (target >= maxScroll - 5) target = 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isMobile()) return;
      timer = setInterval(nextSlide, interval);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    track.addEventListener('touchstart', function () {
      paused = true;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', function () {
      paused = false;
      setTimeout(startAutoplay, 2000);
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (isMobile()) { startAutoplay(); } else { stopAutoplay(); track.scrollLeft = 0; }
      }, 250);
    });

    /* Asegurar que la primera tarjeta parte centrada */
    if (isMobile()) { track.scrollLeft = 0; }
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();
})();
